import { createCommonContextProvider } from "@poscon/shared-frontend";
import { useRootDispatch } from "~/redux/hooks";
import { setViewPosition } from "~/redux/slices/edstSlice";
import type { EdstView } from "~/types/edstView";
import { processEramMessage } from "~redux/thunks/processEramMessage";

export const CCommonContextProvider = createCommonContextProvider(
  () => {
    const dispatch = useRootDispatch();
    return (view, pos) => dispatch(setViewPosition({ view: view as EdstView, pos }));
  },
  () => {
    const dispatch = useRootDispatch();
    return (command) => dispatch(processEramMessage(command, true));
  },
);
